/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>PC精彩图集</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <el-form-item prop="id" label="图集ID">
        <el-input clearable oninput="if(value.length > 3) value=value.slice(0, 3)" type="number"  v-model="formInline.id" placeholder="请输入图集ID"></el-input>
      </el-form-item>
      <el-form-item prop="title" label="图集主标题">
        <el-input clearable v-model="formInline.title" placeholder="请输入图集主标题"></el-input>
      </el-form-item>
      <el-form-item prop="platform" label="发布平台">
        <el-input clearable v-model="formInline.platform" placeholder="请输入发布平台"></el-input>
      </el-form-item>
   
      <el-form-item prop="contentType" label="图集位置">
        <el-select v-model="formInline.contentType">
          <el-option v-for="item in tujiaddserss" :key="item.code" :label="item.desc" :value="item.code">
          </el-option>
        </el-select>
        </el-input>
      </el-form-item>
      <el-form-item prop="platformType" label="展示平台 ">
    <el-select v-model="formInline.platformType" placeholder="PC官网">
        <el-option label="PC官网" value=""></el-option>
      <!-- <el-option label="微信小程序" value="1"></el-option>
      <el-option label="抖音小程序" value="2"></el-option>
      <el-option label="移动官网" value="4"></el-option> -->
    </el-select>
  </el-form-item>








      <el-form-item prop="releaseAddress" label="发布地区">
        <el-select v-model="formInline.releaseAddress">
          <el-option v-for="item in addserss" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="status" label="状态 ">
        <el-select v-model="formInline.status" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="启动" value="1"></el-option>
          <el-option label="停用" value="2"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item prop="createBeginTime" label="创建时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.createBeginTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="createEndTime">

            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.createEndTime" style="width: 100%;"></el-date-picker>
          </el-form-item>


        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>



      <div style=" float: right;  ">

        <el-button type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

      </div>
    </el-form>
    <el-table  id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
      @select-all="selectall" @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">

      <el-table-column prop="id" align="center" label="图集ID" width="100">
        <template slot-scope="scope">


<span style="color: blueviolet; font-size: 28px;">{{ scope.row.id }}</span>

</template>

      </el-table-column>
      <el-table-column prop="contentType" align="center" label="图集位置" width="100">
        <template slot-scope="scope">
          <span >{{ scope.row.contentType == 1?'活动回顾':scope.row.contentType==2?'我们结婚了':scope.row.contentType == 3?'恋爱墙':scope.row.contentType == 4?'脱单秘籍':scope.row.contentType == 5?'月娘咨询':'' }}</span>
       
        </template>

      </el-table-column>
      <el-table-column  prop="platformTypeDesc"  align="center" label="展示平台" width="150">
 
    </el-table-column>
      <el-table-column prop="title" align="center" label="图集主标题" width="200">
      </el-table-column>
      <el-table-column prop="subTitle" align="center" label="图集副标题" width="200">
      </el-table-column>

      <el-table-column prop="headIcon" align="center"  label="图集照片" width="180">
        <template slot-scope="scope">
          <el-image style="width: 120px; height: 120px;" :src="scope.row.images[0]"
            :preview-src-list="scope.row.images" />
        </template>
      </el-table-column>

      <el-table-column prop="platform" align="center"  label="发布平台" width="150">
      </el-table-column>
      <el-table-column prop="version" label="发布时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.releaseTime | timestampToTime }}</div><br>
        </template>
      </el-table-column>
      <el-table-column prop="releaseAddress" label="发布地区" width="150">

      </el-table-column>

      <el-table-column prop="statusDesc" label="状态" align="center"  width="100">

        <template slot-scope="scope">
          <el-tag :type=" scope.row.statusDesc=='启用'?'success':'danger'">{{ scope.row.statusDesc }}</el-tag>
        </template>


      </el-table-column>
      <el-table-column prop="version" label="创建时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime | timestampToTime }}</div><br>

        </template>
      </el-table-column>



      <el-table-column align="center" fixed="right" prop="version" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="primary">编辑</el-button>
        </template>
      </el-table-column>



    </el-table>

    <!--列表-->

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
      @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px;">
      <!-- <el-button @click="selectallsdss(listData)" type="primary">全选</el-button> -->
      <!-- <el-button @click="deleList(listData)" type="primary">删除</el-button> -->



    </div>

    <el-dialog  :close-on-click-modal="false" :title="title" ref="editForm" center :visible.sync="editFormVisible" width="60%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

        <!-- <el-form-item label="展示平台" prop="platformType">
    <el-checkbox-group v-model="editForm.platformType">
    <el-checkbox label="1">微信小程序</el-checkbox>
    <el-checkbox label="2">抖音小程序</el-checkbox>
    <el-checkbox label="4">移动官网</el-checkbox>
  </el-checkbox-group>
        </el-form-item></br> -->
        <el-form-item prop="contentType" label="图集位置">
          <el-radio-group v-model="editForm.contentType">
            <el-radio label="1">活动回顾</el-radio>
            <el-radio label="2">我们结婚了</el-radio>
            <el-radio label="3">恋爱墙</el-radio>
            <el-radio label="4">脱单秘籍</el-radio>
            <el-radio label="5">月娘资讯</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="图集主标题" prop="title">
          <el-input maxlength="30" style="width: 300px;" v-model="editForm.title" auto-complete="off"
            placeholder="请输入30个中文字以内"></el-input>
        </el-form-item>
        <el-form-item label="图集副标题" prop="subTitle">
          <el-input maxlength="200" style="width: 300px;" v-model="editForm.subTitle" auto-complete="off"
            placeholder="请输入200个中文字以内"></el-input>
        </el-form-item>
        <el-form-item label="发布平台" prop="platform">
          <el-input style="width: 300px;" v-model="editForm.platform" auto-complete="off"
            placeholder="请输入发布平台"></el-input>
        </el-form-item>


        <!-- <el-form-item label="图集封面" prop="images">
          <el-upload :class="{ disabled: uploadDisabled }" :action=ssoServerimg
            list-type="picture-card" :limit="10" :on-exceed="Onexceed" multiple :on-change="uploadSectionFile"
            :before-upload="beforeUpload" :file-list="fileList" :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>

          <span style="color: red;">最多上传10张(750*564px)</span>

        </el-form-item> -->


        <el-form-item label="图集封面" prop="images">
  <div>
    <!-- 使用element-ui自带样式 -->
      <ul class="el-upload-list el-upload-list--picture-card">
          <draggable v-model="editForm.images">
              <li v-for="(item, index) in editForm.images" :key="item.uid" class="el-upload-list__item is-success animated">
                  <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                  <i class="el-icon-close"></i>
                  <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreviewFileDetail(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="handleRemoveFileDetail(index,editForm.images)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
              </li>
          </draggable>
      </ul>
      <el-upload :class="{ disabled: uploadDisabled }" :action=ssoServerimg
            list-type="picture-card" :limit="10" :on-exceed="Onexceed" multiple :on-change="uploadSectionFile"
            :before-upload="beforeUpload" :file-list="fileList"  :show-file-list="false" :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
  </div>
  <span style="color: red;">最多上传10张(750*564px)</span>
  <!-- 预览弹出层 -->

  <!-- <el-dialog  :visible.sync="dialogVisibleDetail">
      <img width="100%" :src="dialogImageDetailUrl" alt="">
  </el-dialog> -->
</el-form-item>



<el-form-item label="分享图片" prop="cover">
          <el-upload 
          :limit='1'
          :class="{ disabled: uploadDisableds }" 
         
  :action=ssoServerimg
  list-type="picture-card"
  tokenId:this.adder
  :before-upload="beforeUpload"
  :file-list="Formcover"
  :on-preview="handlePictureCardPreview"
  :on-success="handleAvatarX"
  :on-remove="handleRemoveX">
  <i class="el-icon-plus"></i>
</el-upload>
        </el-form-item>
        <el-form-item label="指定发布日期" prop="releaseTime">
          <el-date-picker v-model="editForm.releaseTime" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发布地区" prop="releaseAddress">
          <el-input style="width: 300px;" v-model="editForm.releaseAddress" auto-complete="off"
            placeholder="请输入发布地区"></el-input>
        </el-form-item>

        <el-form-item v-if="indexs == 2" label="状态" prop="status">
          <el-radio v-model="editForm.status" label="1">启用</el-radio>
          <el-radio v-model="editForm.status" label="2">禁用</el-radio>
        </el-form-item>
        <el-form-item label="活动详情" prop="content">
          <quill-editor class="editor" v-model="editForm.content" ref="myQuillEditor" :options="editorOption"
            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
          </quill-editor>
        </el-form-item><br>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('editForm ')">取消</el-button>
        <el-button type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="昵称审核" :visible.sync="dialogVisible" width="30%">
      <span>确定是否审核吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="OndialogVisible">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblesss">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  

    <div v-show="false">
      <el-upload class="avatar-uploader" :action=ssoServerimg
        list-type="picture-card" tokenId:this.adder :before-upload="beforeUpload" :on-change="uploadSectionFile"
        :on-success="uploadSuccess" :on-remove="handleRemove">

        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
    <div v-show="false">
      <el-upload class="avatar-uploaders" :action=ssoServerimg
        list-type="picture-card" tokenId:this.adder :before-upload="beforeUpload" :on-change="uploadSectionFile"
        :on-success="uploadSuccessx" :on-remove="handleRemove">

        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
let tokenId = localStorage.getItem('tokenId');
import Vue from 'vue'

import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
import Quill from "quill";
// Quill.register('modules/quillEmoji', quillEmoji)
let fontFamily = ['Courier New', 'Georgia', 'serif', 'noto', 'Arial',];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import * as imageConversion from 'image-conversion';
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],
  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
  [{ 'direction': 'rtl' }],                         // text direction
  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  [{ font: fontFamily }], // 字体
  [{ 'align': [] }],
  ['link', 'image', 'video'],
  ['clean'],
  ['emoji'],//表情包          
                             // remove formatting button
]

import draggable from 'vuedraggable'
import Axios from 'axios'
import { login } from "../../api"

import { Video } from '../charts/video';
const quill = require('quill');
// import draggable from 'uedraggbale'
quill.register({ 'formats/video': Video }, true);
import Pagination from '../../components/Pagination'
export default {
  // components: {
  //           draggable,
  //       },
  data() {
    return {
      ssoServer:"",
      ssoServerimg:"",
      // dialogVisibleDetail:true,
      dialogVisibleDetail:false,
      editorOption: {
        placeholder: '',
        theme: 'snow',  // or 'bubble'
        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: {
            container: toolbarOptions,  // 工具栏
            handlers: {
              'image': function (value) {
                if (value) {
                  // console.log(value);
                  document.querySelector('.avatar-uploader input').click()
                } else {
                
                  this.quill.format('image', false);
                }
              },
              // 'emoji':function(value){
              //       console.log(value,'1111111111111111');
              // },
              'video': function (value) {
                if (value) {
                  document.querySelector('.avatar-uploaders input').click()
                } else {
                  this.quill.format('video', false);
                }
                // console.log(value);
              },


            }
          }
        }
      },
      dialogImageUrl: '',
      fileList: [],
      dialogImageDetailUrl:[],
      listsss: [],
      Formcover:[],
      dialogVisible: false,
      uploadDisableds:false,
      fileDetailList: [],
      addserss: "",
      tujiaddserss: '',
      dialogVisiblesss: false,
      uploadDisabled: false,
      indexfff: 1,
      indexs: "",
      formInline: {
        platformType:"",
        isPC:1,
        contentType: '',
        platform: "",
        id: "",
        platformd: "",
        releaseAddress: "",
        title: "",
        status: "",
        createBeginTime: "",
        createEndTime: "",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },

      dialogFormVisibleicn: false,
      activeName: '1',
      userlist: "",
      radio: "",
      cityOptions: [{
        name: "审核未通过",
        lis: -1,

      }, {
        name: "10",
        lis: 10,

      }, {
        name: "20",
        lis: 20,

      }, {
        name: "30",
        lis: 30,

      }, {
        name: "40",
        lis: 40,

      }, {
        name: "50",
        lis: 50,

      }, {
        name: "60",
        lis: 60,

      }, {
        name: "70",
        lis: 70,

      }, {
        name: "80",
        lis: 80,

      }, {
        name: "90",
        lis: 90,

      }, {
        name: "100",
        lis: 100,

      }],
      dialogFormVisible: false,
      checkList: [],
      adder: "",
      options123: [],
      undataList: "",
      options1234123: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加精彩图集',

   
      ifswlimages: [],
      editForm: {
        platformType:[],
        cover:"",
        contentType: "",
        id: "",
        status: "",
        content: [],
        releaseAddress: "",
        platform: "",
        releaseTime: "",
        subTitle: "",
        images: [],
        title: "",
      },

      // rules表单验证
      rules: {
        
        cover: [
          { required: true, message: '分享图片不能为空', trigger: 'blur' }
        ],
        platformType: [
          { required: true, message: '展示平台不能为空', trigger: 'blur' }
        ],
        
        addDeer: [
          { required: true, message: '请选择位置', trigger: 'blur' }
        ],
        contentType: [{ required: true, message: '图集位置不能为空', trigger: 'blur' }],

        title: [{ required: true, message: '主标题不能为空', trigger: 'blur' }],
        subTitle: [{ required: true, message: '副标题不能为空', trigger: 'blur' }],
        platform: [{ required: true, message: '发布平台不能为空', trigger: 'blur' },
        { min: 0, max: 10, message: '长度在 0 到 10 个字符', trigger: 'blur' }
        ],

        // images: [{ required: true, message: '视频封面不能为空', trigger: 'blur' }],
        releaseTime: [{ required: true, message: '指定发布日期不能为空', trigger: 'blur' }],
        releaseAddress: [{ required: true, message: '发布地址不能为空', trigger: 'blur' },
        { min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur' }
        ],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
        images: [{ required: true, message: '图集封面不能为空', trigger: 'blur' }]




      },

      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    draggable,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    this.ssoServerimg=Vue.prototype.GLOBAL.ssoServerimg
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId


    // this.getdata(this.formInline)
  },
  mounted() {
    this.formLIst()
    this.getAddress()
    this.getAddresss()

    Axios({
      method: 'get',
      url: this.ssoServer+'/api//platform-wonderful-atlas/releaseAddressList',
      headers: {
        tokenId: this.adder
      },

    }).then(res => {
      if (res.data.code == 999) {
        setTimeout(() => {
          localStorage.removeItem('tokenId')

          this.$store.commit('logout', 'false')
          this.$router.push({ path: '/login' })
          this.$message({
            type: 'success',
            message: '登录过期,请重新登录'
          })
        }, 1000)
      }
      this.addserss = res.data.data
      return console.log(res, '121212121212121212121212');


    })
    Axios({
      method: 'get',
      url: this.ssoServer+'/api//platform-wonderful-atlas/getAddressList',
      headers: {
        tokenId: this.adder
      },

    }).then(res => {
      if (res.data.code == 999) {
        setTimeout(() => {
          localStorage.removeItem('tokenId')

          this.$store.commit('logout', 'false')
          this.$router.push({ path: '/login' })
          this.$message({
            type: 'success',
            message: '登录过期,请重新登录'
          })
        }, 1000)
      }
      this.tujiaddserss = res.data.data
      return console.log(res, '121212121212121212121212');


    })




  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handlePictureCardPreviewFileDetail(file) {
     
      this.dialogVisiblesss = true;
 
    this.dialogImageUrl = file;
   
},
// 删除
handleRemoveFileDetail(index,fileList) {
  // console.log(index,item);
  
  this.editForm.images.splice(index, 1);
  this.fileList.splice(index,1)
  console.log(fileList.length);
  if (fileList.length >= 10) {
        this.uploadDisabled = true;
      }else{
        this.uploadDisabled = false;
      }
  // this.uploadDisabled = false;
},


    onEditorBlur() {
    },
    onEditorFocus() {//获得焦点事件
    },
    onEditorChange() {//内容改变事件
      // console.log(this.ruleForm.content);

    },


    uploadSuccess(res, file) {

      console.log(res, file);
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill

      // 如果上传成功
      //  return console.log(res.code);
      if (res.code == '0') {

        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, 'image', res.data)
        // quill.insertEmbed(length, 'video', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        console.log('2222');
        this.$message.error('图片插入失败')
      }
      // loading动画消失
    },
    uploadSuccessx(res, file) {

      console.log(res, file);
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill

      // 如果上传成功
      //  return console.log(res.code);
      if (res.code == '0') {

        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        // quill.insertEmbed(length, 'image', res.data)
        quill.insertEmbed(length, 'video', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        console.log('2222');
        this.$message.error('图片插入失败')
      }
      // loading动画消失
    },





    beforeUpload(file) {
      console.log(file);
      const isLt50M = file.size / 1024 / 1024 < 30;
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 30MB!');
        return
      }
      const _that = this

      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif";
      if (file.type == "video/mp4") {
        var isLt2M = file.size / 1024 / 1024 < 30;
      } else {
        var isLt2M = file.size / 1024 / 1024 < 2;
      }

      if (!isJpgOrPng) {
        this.$message.error("上传图片只能是JPG或PNG或GIF格式!");
        return false;
       
      }
      return new Promise((resolve) => {
        // 小于2M 不压缩
        if (isLt2M) {
          resolve(file)
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then((res) => {
          console.log(res);
          resolve(res);
        });
      });
    },
    Onexceed() {
      console.log();
    },


    uploadSectionFile(file, fileList) {
      console.log(fileList);
      if (fileList.length >= 10) {
        this.uploadDisabled = true;
      }
    },
    
    handleAvatarX(res, file){
      this.Formcover=res.data
     
      this.editForm.cover = res.data
          
      if (this.editForm.cover) {
        this.uploadDisableds = true;
      }else{
        this.uploadDisableds = false;
      }
    },
    handleAvatarSuccess(res, file) {
      this.listsss.push(res.data)
      this.editForm.images = this.listsss
          
      if (this.editForm.images.length >= 10) {
        this.uploadDisabled = true;
      }else{
        this.uploadDisabled = false;
      }
    },
    // 删除数据
    deleList() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'success',
          message: '删除的用户不能为空!'
        });
      } else {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      }



    },

    selectallsdss(rows) {
      // console.log("rows : "+JSON.stringify(rows));
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {

        this.$refs.multipleTable.clearSelection();//清除全选
        console.log('2222');

      }


    },
    handleRemoveX(file, fileList){
    this.Formcover=[]
    this.editForm.cover=''
    this.uploadDisableds = false;
    },
    handleRemove(file, fileList) {

      this.uploadDisabled = false;
      if (this.indexs == 1) {
        let newfileList = fileList.map((item) => {
          // console.log(item.response.data)  ;
          return item.response.data


        });
        this.editForm.images.push(newfileList)
        this.listsss = newfileList;

      } else if (this.indexs == 2) {

        let newfileLists = fileList.map((item) => {
          return item.url
        });
        this.editForm.images = newfileLists
        this.listsss = newfileLists;

      }



    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblesss = true;
    },
    //添加

    // 确定审核
    OndialogVisible() {

      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-nick-name-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          //   appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '审核成功'
          })
          this.formLIst()
        }
      })





    },
    // 查看历史图片
    historyHeadIcons(item) {
      this.historyHea = item
      // console.log(item);
      this.dialogFormVisibleicn = true

    },
    // 颜值打分
    YZdialogFormVisible() {
      if (!this.radio) {
        this.$message({
          type: 'warning',
          message: '选择不能为空'
        })
        return
      }
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-head-icon-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          appearanceScore: this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: '打分成功'
          })
          this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

    },
    handleCheckedCitiesChange() {
      console.log(this.checkList);
    },
    caozClick() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择要审核的用户'
        })
        return

      } else {
        this.dialogVisible = true
        console.log('1111');
      }

    },

    handleClick(tab, event) {
      //  return  console.log(this.activeName);
      if (this.activeName == 1) {
        this.formInline.status = 1
        this.formLIst()
      } else if (this.activeName == 2) {
        this.formInline.status = 2
        this.formLIst()
      } else if (this.activeName == 3) {
        this.formInline.status = 3
        this.formLIst()
      }

    },

    getAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss() {
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },

      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    handleEdit(index, row) {
      this.Formcover=[]
       this.editForm.cover=''
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.fileLis = []
        this.fileList = row.images.map(i => {
          var obj = {}
          obj.url = i
          return obj

        })
      
        this.Formcover.push({
          'url': row.cover  
        })

        if (row.images.length >= 10) {
          this.uploadDisabled = true;

        } else {
          this.uploadDisabled = false;
        }
        if (this.Formcover) {
          this.uploadDisableds = true;

        } else {
          this.uploadDisableds = false;
        }    
        this.indexs = 2
        this.title = '编辑精彩图集'
        // this.uploadDisabled = false;
        this.editForm.id = row.id
        this.editForm.status = String(row.status)
        this.editForm.contentType = String(row.contentType)
        this.editForm.content = row.content
        this.listsss = row.images
        if(row.cover){
          this.editForm.cover=row.cover
        }else{
          this.uploadDisableds = false
         
          this.Formcover=[]
        }
        this.editForm.platformType=[3]
       
        this.editForm.images = this.listsss
        // console.log(this.Formcover);
        this.editForm.releaseAddress = row.releaseAddress
        // this.editForm.images = row.images
        this.editForm.platform = row.platform
        this.editForm.releaseTime = row.releaseTime
        this.editForm.subTitle = row.subTitle
        this.editForm.title = row.title

      } else {
        
        this.fileLis = ''
        this.uploadDisabled = false,
        this.uploadDisableds = false,
        this.indexs = 1
        this.title = '添加精彩图集'
        this.fileList = []
        this.Formcover=[]
        this.listsss = []
        this.editForm.platformType=[3]
        this.editForm.cover=''
        this.editForm.content = ''
        this.editForm.contentType = ''
        this.editForm.releaseAddress = ''
        this.editForm.platform = ''
        this.editForm.releaseTime = ''
        this.editForm.subTitle = ''
        this.editForm.images = ''
        this.editForm.title = ''
      }
    },

    selectalls(rows) {
      console.log(rows);
      this.userlist = rows
      this.indexs = 2
      if (this.indexs == 2) {
        this.title = '编辑banner'

        let add = String(rows.type)
        let adder=String(rows.platformType)
        //  return  console.log(add);

        this.editFormVisible = true
        this.editForm = this.userlist
        this.editForm.type = add
        this.editForm.platformType=adder
        this.editForm
      }

      // this.undataList =rows

      console.log(rows);
    },

    onChanges(e) {
      // console.log(e);
      this.formInline.releaseAddress = e[1]
      // console.log( this.formInline.registerAddress);
    },
    selectall(val) {
      console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      this.$refs[formInline].resetFields();
    },


    formLIst() {
      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/platform-wonderful-atlas/listByPlatform',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        } else if (res.data.code == 500) {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
        this.listData = res.data.data.list
        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;

      // 测试参数含义：不知道参数是什么含义的就打印出来
      // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
      // console.log(column)  	//拿到列的信息
      // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
      // console.log(index)     //拿到索引
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,

      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)

    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {

      this.formInline.current = 1
      this.formLIst()


    },

    submitForm(editForm) {

      this.$refs[editForm].validate((valid) => {
        if (valid) {



          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            if (this.indexs == 1) {
              Axios({
                method: 'post',
                url: this.ssoServer+'/api//platform-wonderful-atlas/add',
                headers: {
                  tokenId: this.adder
                },
                data: this.editForm
              }).then(res => {
                if (res.data.code == 999) {
                  setTimeout(() => {
                    localStorage.removeItem('tokenId')

                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '登录过期,请重新登录'
                    })
                  }, 1000)
                }
                // return console.log(res.data.code);
                if (res.data.code == 0) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '添加成功'
                  })
                  this.ifswlimages = []
                  this.listsss = []
                  this.Formcover=[]
                  this.formLIst()


                }

              })


            } else {

              Axios({
                method: 'post',
                url: this.ssoServer+'/api/platform-wonderful-atlas/edit',
                headers: {
                  tokenId: this.adder
                },
                data: this.editForm
              }).then(res => {
                if (res.data.code == 999) {
                  setTimeout(() => {
                    localStorage.removeItem('tokenId')

                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '登录过期,请重新登录'
                    })
                  }, 1000)
                }
                // return console.log(res.data.code);
                if (res.data.code == 0) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  })
                  this.ifswlimages = []
                  this.Formcover=[]
                  // this.editForm.cover=''
                  // this.listsss=[]
                  this.formLIst()
                }

              })




              console.log('编辑');
            }
            loading.close();
          }, 500);




        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(editForm) {
      // this.editForm.cover=''
      this.formLIst()
      // this.Formcover=[]
      // this.formLIst()
      this.ifswlimages = []
      // this.fileList=[]

      // this.$refs[editForm].resetFields();
      this.editFormVisible = false
    }
  }
}
</script>

<style>
.ql-snow .ql-picker.ql-font{
  width: 80px;  
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Arial']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Arial']::before {
  content: 'Arial';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Courier New']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Courier New']::before {
  content: 'Courier New';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Georgia']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Georgia']::before {
  content: 'Georgia';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: 'serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='noto']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='noto']::before {
  content: 'noto';
}


.el-upload-list__item {
  transition: none !important;
}

.disabled .el-upload--picture-card {
  display: none !important;
}

.dialogForm {
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .dialogFormChl {
    margin-top: 20px;

    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }

  .dialogFormChl img {
    width: 100%;
    height: 200px;
  }
  
}

.user-search {
  margin-top: 20px;
}


.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/officialWebsite/PCcounPewrs.vue